'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var trialIdAdapter = function trialIdAdapter(availableTrials, merchandiseId) {
  if (merchandiseId === _MerchandiseIds.ADDON_CMS) {
    var cmsTrialAvailable = availableTrials.filter(function (t) {
      return t.name === 'cms';
    })[0];
    if (cmsTrialAvailable) {
      return cmsTrialAvailable.trialId;
    }
    return null;
  }

  var trial = availableTrials.filter(function (t) {
    return t.merchandiseId === merchandiseId;
  })[0];

  if (!trial) return null;
  return trial.trialId;
};

exports.default = trialIdAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/trialIdAdapter.js
// module id = 363
// module chunks = 3 4 5